import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { Badge } from 'primereact/badge';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Icon } from '@iconify/react';
import { CCol, CFormLabel, CRow } from '@coreui/react';
import { useOrder } from '../contexts/OrderContext';
import { useCompanySetting } from '../contexts/CompanySettingContext';
import { orderNav } from '../components/NavigationPath';
import Layout2 from '../components/Layout2';

function OrderDetail() {
    const { getSingleOrder } = useOrder();
    const { currency } = useCompanySetting();

    const { id } = useParams()

    const [orderDetail, setOrderDetail] = useState(null);
    const [productList, setProductList] = useState([]);
    const [comboList, setComboList] = useState([]);
    const [orderStatus, setOrderStatus] = useState(null)
    const [expandedProductRows, setExpandedProductRows] = useState(null);
    const [expandedComboRows, setExpandedComboRows] = useState(null);

    const fetchSingleOrder = async () => {
        try {
            const order = await getSingleOrder(id);
            setOrderDetail(order);

            if (order.products) {
                setOrderStatus(order.status)

                const products = order.products.filter((product) => !product.is_combo);
                setProductList(products);

                const combos = order.products.filter((product) => product.is_combo);
                setComboList(combos);
            }
        } catch (error) {
            console.error('Error fetching single order', error);
        }
    };

    useEffect(() => {
        if (id) fetchSingleOrder();
    }, [id]);

    const allowExpansion = (rowData) => {
        return (rowData.modifiers?.length > 0) || (rowData.choices?.length > 0);
    };

    const rowExpansionTemplate = (data, type) => {
        const label = type === 'modifier' ? 'Modifiers' : 'Products';
        const items = data.modifiers;

        return (
            <div className="ps-3 border-bottom">
                <CRow>
                    <CFormLabel>{label}</CFormLabel>
                </CRow>
                {items && items.length > 0 && (
                    <DataTable
                        className={`${type === 'modifier' ? 'modifierTable' : 'choiceTable'} thead`}
                        lazy
                        value={items}
                        dataKey="id"
                        emptyMessage={`No ${label.toLowerCase()} found.`}
                    >
                        <Column
                            field="id"
                            header="#ID" />
                        <Column
                            field="name"
                            header="Name" />
                        <Column
                            field="quantity"
                            header="Quantity" />
                        <Column
                            field="price"
                            header="Price"
                            body={(rowData) => <div>{currency}{rowData.price}</div>}
                        />
                        <Column
                            field="modified_price"
                            header="Final Price"
                            body={(rowData) => <div>{currency}{rowData.modified_price}</div>}
                        />
                    </DataTable>
                )}
            </div>
        );
    };

    return (
        <Layout2 items={orderNav.items} navTitle={orderNav.header}>
            <div className="d-flex flex-column w-100">
                <div className='d-flex flex-row justify-content-between px-4 py-2 w-100 border-bottom'>
                    <h4>Orders Detail <Badge value={`#${id}`} severity="info" className='order_id' /></h4>
                    <div className='pt-1'>
                        {
                            orderStatus && orderStatus === 'in_progress' ?
                                (
                                    <Badge value="in_progress" severity="warning" className='order_status' />
                                ) : (
                                    <Badge value="completed" severity="success" className='order_status' />
                                )
                        }
                    </div>
                </div>
                <div className='px-4 py-2 d-flex'>
                    <div className='left-container'>
                        <CRow className='pt-2 mb-2'>
                            <CFormLabel>Products</CFormLabel>
                        </CRow>
                        {orderDetail?.products?.length > 0 && (
                            <DataTable
                                className="orderTable"
                                lazy
                                value={productList}
                                dataKey="id"
                                emptyMessage="No products found."
                                expandedRows={expandedProductRows}
                                onRowToggle={(e) => setExpandedProductRows(e.data)}
                                rowExpansionTemplate={(data) => rowExpansionTemplate(data, 'modifier')}
                            >
                                <Column
                                    expander={allowExpansion}
                                    style={{ width: '3em' }} />
                                <Column
                                    header="Image"
                                    body={(rowData) => (
                                        <div>
                                            {rowData.image ? (
                                                <img src={rowData.image} width="60px" className="product-img-order" alt={rowData.name} />
                                            ) : (
                                                <Icon icon="mdi:food-outline" className="product-img-order" style={{ color: "black" }} />
                                            )}
                                        </div>
                                    )}
                                />
                                <Column
                                    field="name"
                                    header="Name"
                                    className='order-product-name' />
                                <Column
                                    field="quantity"
                                    header="Quantity" />
                                <Column
                                    field="price"
                                    header="Price"
                                    body={(rowData) => <div>{currency}{rowData.price}</div>}
                                />
                                <Column
                                    field="modified_price"
                                    header="Final Price"
                                    body={(rowData) => <div>{currency}{rowData.modified_price}</div>}
                                />
                            </DataTable>
                        )}
                        {comboList.length > 0 && (
                            <DataTable
                                className="comboTable thead-dark orderTable"
                                lazy
                                value={comboList}
                                dataKey="id"
                                emptyMessage="No products found."
                                expandedRows={expandedComboRows}
                                onRowToggle={(e) => setExpandedComboRows(e.data)}
                                rowExpansionTemplate={(data) => rowExpansionTemplate(data, 'product')}
                            >
                                <Column
                                    expander={allowExpansion}
                                    style={{ width: '3em' }} />
                                <Column
                                    header="Image"
                                    body={(rowData) => (
                                        <div>
                                            {rowData.image ? (
                                                <img src={rowData.image} width="60px" className="product-img-order" alt={rowData.name} />
                                            ) : (
                                                <Icon icon="mdi:food-outline" className="product-img-order" style={{ color: "black" }} />
                                            )}
                                        </div>
                                    )}
                                />
                                <Column
                                    field="name"
                                    header="Name"
                                    className='order-product-name' />
                                <Column
                                    field="quantity"
                                    header="Quantity" />
                                <Column
                                    field="price"
                                    header="Price"
                                    body={(rowData) => <div>{currency}{rowData.price}</div>}
                                />
                                <Column
                                    field="modified_price"
                                    header="Final Price"
                                    body={(rowData) => <div>{currency}{rowData.modified_price}</div>}
                                />
                            </DataTable>
                        )}
                    </div>
                    <div className='right-container'>
                        <div>
                            {orderDetail?.customer && (
                                <div className='ps-3 pt-2'>
                                    <CRow className='border-bottom mb-2'>
                                        <CFormLabel>Customer Detail</CFormLabel>
                                    </CRow>
                                    <div className='ms-3'>
                                        <CRow>
                                            <CCol lg={2}>
                                                <CFormLabel>Name: </CFormLabel>
                                            </CCol>
                                            <CCol lg={10}>
                                                {orderDetail.customer.firstName} {orderDetail.customer.lastName}
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol lg={2}>
                                                <CFormLabel>Email: </CFormLabel>
                                            </CCol>
                                            <CCol lg={10}>
                                                {orderDetail.customer.email || '-'}
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol lg={2}>
                                                <CFormLabel>Phone: </CFormLabel>
                                            </CCol>
                                            <CCol lg={10}>
                                                {orderDetail.customer.phone || '-'}
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div>
                            {orderDetail && (
                                <div className='ps-3 pt-3'>
                                    <CRow className='border-bottom mb-2'>
                                        <CFormLabel>Payment Detail</CFormLabel>
                                    </CRow>
                                    <div className='ms-3'>
                                        <CRow>
                                            <CCol lg={5}>
                                                <CFormLabel>Sub Total</CFormLabel>
                                            </CCol>
                                            <CCol lg={1}>
                                                <CFormLabel>{currency}{orderDetail.sub_total}</CFormLabel>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol lg={5}>
                                                <CFormLabel className='text-secondary'>Discount</CFormLabel>
                                            </CCol>
                                            <CCol lg={1} className='text-secondary'>
                                                <CFormLabel>{currency}{orderDetail.discount}</CFormLabel>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol lg={5}>
                                                <CFormLabel className='w-100'>Total Amount</CFormLabel>
                                            </CCol>
                                            <CCol lg={1} className='text-success'>
                                                <CFormLabel>{currency}{orderDetail.total}</CFormLabel>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Layout2>
    );
}

export default OrderDetail